// extracted by mini-css-extract-plugin
export var actions = "_c2-g";
export var benefitCard = "_c2-b";
export var benefitIcon = "_c2-d";
export var benefitLabel = "_c2-f";
export var benefits = "_c2-a";
export var benefitsSection = "_c2-8";
export var bodyText = "_c2-7";
export var closeButton = "_c2-2";
export var content = "_c2-3";
export var eyebrow = "_c2-4";
export var heading = "_c2-5";
export var image = "_c2-i";
export var imagePanel = "_c2-h";
export var modal = "_c2-0";
export var offerCard = "_c2-c";
export var offerIcon = "_c2-e";
export var sectionLabel = "_c2-9";
export var shell = "_c2-1";
export var title = "_c2-6";